import { FC, ReactNode, useContext } from "react";
import { BoardContext } from "../../../context";

interface BluredBlueModalProps {
    children: ReactNode;
    fullDarkBackground?: boolean;
}

const BluredBlueModal: FC<BluredBlueModalProps> = ({ children, fullDarkBackground }) => {
    const { isWinnersPodiumShown } = useContext(BoardContext);
    const blureBlueModalStyle = isWinnersPodiumShown ? {zIndex: 25} : {};

    return (
        <div className={`${fullDarkBackground ? "blured_blue_modal_wrapper_full_dark" : "blured_blue_modal_wrapper"} full_screen`} style={blureBlueModalStyle}>
            <div className="blured_blue_modal_wrapper center_horizontally_and vertically full_screen">
                {children}
            </div>
        </div>
    )
}

export default BluredBlueModal;